import { ComponentProps } from 'react';
import { Button } from '../../../../../design-system/button/button';
import { Inline } from '../../../../../design-system/inline/inline';
import { Stack } from '../../../../../design-system/stack/stack';
import { TransactionView } from '../../../../../types/entity-types';
import { InvoiceCard } from '../invoice-card';
import { MarkAsPaidInvoiceTable } from '../mark-as-paid-invoice-table';

type MarkAsPaidModalContentProps = {
  invoiceInfo: ComponentProps<typeof InvoiceCard>;
  transactions: TransactionView[];
  selectedPaidTransactionId?: string;
  canMarkAsPaidWithoutMatching?: boolean;
  isMatching: boolean;
  isMarkingAsPaid: boolean;
  onToggleTransaction: (transactionId: string) => void;
  onMatchToTransaction: () => Promise<void>;
  onMarkAsPaidWithoutMatching: () => Promise<void>;
};

export const MarkAsPaidModalContent = ({
  invoiceInfo,
  transactions,
  selectedPaidTransactionId,
  canMarkAsPaidWithoutMatching = true,
  isMatching,
  isMarkingAsPaid,
  onToggleTransaction,
  onMatchToTransaction,
  onMarkAsPaidWithoutMatching,
}: MarkAsPaidModalContentProps) => {
  return (
    <Stack space={4} align="stretch" justify="between">
      <Stack className="flex-1" space={4} align="stretch">
        <h1 className="text-xl leading-6 font-medium tracking-tight text-black">
          Select the transaction to match this invoice to
        </h1>

        <Stack align="stretch">
          <InvoiceCard {...invoiceInfo} />

          <MarkAsPaidInvoiceTable transactions={transactions} onToggleTransaction={onToggleTransaction} />
        </Stack>
      </Stack>

      <Inline space={2}>
        <Button
          variant="default"
          disabled={transactions.length === 0 || isMarkingAsPaid || !selectedPaidTransactionId}
          isLoading={isMatching}
          onClick={onMatchToTransaction}
        >
          Match to transaction
        </Button>

        {canMarkAsPaidWithoutMatching && (
          <Button
            variant="secondary"
            disabled={isMatching}
            isLoading={isMarkingAsPaid}
            onClick={onMarkAsPaidWithoutMatching}
          >
            Mark as paid without matching
          </Button>
        )}
      </Inline>
    </Stack>
  );
};
